"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportFieldToJSON = exports.ReportFieldFromJSONTyped = exports.ReportFieldFromJSON = exports.instanceOfReportField = void 0;
var runtime_1 = require("../runtime");
var ReportFieldType_1 = require("./ReportFieldType");
/**
 * Check if a given object implements the ReportField interface.
 */
function instanceOfReportField(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfReportField = instanceOfReportField;
function ReportFieldFromJSON(json) {
    return ReportFieldFromJSONTyped(json, false);
}
exports.ReportFieldFromJSON = ReportFieldFromJSON;
function ReportFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fieldType': !(0, runtime_1.exists)(json, 'field_type') ? undefined : (0, ReportFieldType_1.ReportFieldTypeFromJSON)(json['field_type']),
        'fieldValue': !(0, runtime_1.exists)(json, 'field_value') ? undefined : json['field_value'],
    };
}
exports.ReportFieldFromJSONTyped = ReportFieldFromJSONTyped;
function ReportFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'field_type': (0, ReportFieldType_1.ReportFieldTypeToJSON)(value.fieldType),
        'field_value': value.fieldValue,
    };
}
exports.ReportFieldToJSON = ReportFieldToJSON;
